export type MenuItemTranslation = {
  key?: string | null
  language?: string | null
  value?: string | null
}

type Params = {
  translations?: MenuItemTranslation[] | null
  locale?: string | null
  key: string
  fallback?: string | null
}

export const getMenuItemTranslatedValue = ({
  translations,
  locale,
  key,
  fallback,
}: Params): string => {
  const normalizedFallback = fallback ?? ''
  const normalizedLocale = locale?.toLowerCase()
  const translationList = translations ?? []

  const byLocale = translationList.find(
    (translation) =>
      translation.key === key &&
      translation.language?.toLowerCase().startsWith(normalizedLocale ?? ''),
  )?.value

  if (byLocale) return byLocale

  const byEnglish = translationList.find(
    (translation) =>
      translation.key === key && translation.language?.toLowerCase().startsWith('en'),
  )?.value

  return byEnglish ?? normalizedFallback
}
